(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["announcement-bar"]) return;
  try {
    
(() => {
  const sale = document.querySelector('[data-hilltop-flash-sale]');
  if (!sale) return;
  const expiry = Date.parse(sale.dataset.ends);
  if (!Number.isFinite(expiry)) return;
  const restore = () => {
    if (Date.now() < expiry) return;
    sale.remove();
    const normal = document.querySelector('[data-hilltop-normal-announcement]');
    if (normal) normal.hidden = false;
    clearInterval(timer);
  };
  const timer = setInterval(restore, 1000);
  restore();
})();

  } catch(e) { console.error(e); }
})();
})();
